import { render, staticRenderFns } from "./EditTaskGroupColumn.vue?vue&type=template&id=55f91a16&"
import script from "./EditTaskGroupColumn.vue?vue&type=script&lang=js&"
export * from "./EditTaskGroupColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports